import React, {useEffect, useRef, useState} from 'react';
import classnames from "classnames";
import WindowEventHelper from "../../lib/WindowEventHelper";
import {isDescendant} from "../../utils/DomHelper";

const APPROVE = 'approve';

// 미승인
const REJECT = 'reject';

// Status Items
const STATUS_ITEMS = [
  {id: APPROVE, label: '승인'},
  {id: REJECT, label: '미승인'},
];

/**
 * Status Button
 * @param props
 * @returns {*}
 * @constructor
 */
export default function CommentStatusButtonItem(props) {

  const [open, setOpen] = useState(false);                          // Layer open
  const [activeItem, setActiveItem] = useState(STATUS_ITEMS[0]);    // Status isApproved true 이면 APPROVE false 이면 reject
  const rootEl = useRef(null);
  const {handleApprove, handleReject, item} = props;

  useEffect(() => {

    setActiveItem(getStatus(props.item.isApproved));

    WindowEventHelper.add("click", handleWindowClick);
    return function cleanup() {
      WindowEventHelper.remove("click", handleWindowClick);
    }

  });

  function handleWindowClick(e) {
    if (!isDescendant(rootEl.current, e.target)) {
      setOpen(false);
    }
  }

  // isApproved 값을 이용해서 approved인지 reject인지 판별
  function getStatus(isApproved) {
    return STATUS_ITEMS.find((statusItem) => {
      return statusItem.id == (isApproved ? APPROVE : REJECT);
    });
  }

  // 상태값 변경
  function changeHandler(statusItem) {

    if (statusItem.id == activeItem.id) {
      setOpen(false);
      return;
    }

    switch (statusItem.id) {
      case APPROVE :
        handleApprove(item);
        break;
      case REJECT :
        handleReject(item);
        break;
    }

    setActiveItem(statusItem);  // active item 변경
    setOpen(false);             // layer hidden
  }

  return <div ref={rootEl} className={classnames(`opt_set`, {
    'opt_open': open,
    'change_on': item.processing
  })} onMouseLeave={() => setOpen(false)}>
    <button type="button" className="btn_opt" onClick={() => setOpen(true)}>
      <span className="txt_ellip">{activeItem.label}</span>
      <span className="ico_blog ico_open"></span>
    </button>
    <div className="layer_opt">
      {STATUS_ITEMS.map((statusItem, index) => {
        const {id, label} = statusItem;
        return <label className={classnames('lab_set', {on: id == activeItem.id})} key={index}>
          <input type="radio" className="inp_set" value={id} onClick={() => changeHandler(statusItem)}/>
          <span className="txt_set txt_ellip">{label}</span>
        </label>
      })}
      <button type="button" className="btn_close"><span className="ico_blog"></span></button>
    </div>
    <span className="txt_change"> 변경중<span className="ico_blog ico_change"></span></span>
  </div>
}
